import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import RichTextEditor from "../../../../../../../../../components/ui/RichTextEditor";

interface AddAgendaDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (html: string) => Promise<void> | void;
  initialContent?: string;
}

export default function AddAgendaDialog({
  open,
  onClose,
  onSubmit,
  initialContent = "",
}: AddAgendaDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Add Event Agenda</DialogTitle>

      <DialogContent>
        <RichTextEditor
          title="Event Agenda"
          initialContent={initialContent}
          onSave={async (html) => {
            await onSubmit(html);
            onClose();
          }}
          placeholder="Write full event agenda here..."
          saveButtonText="Save Agenda"
        />
      </DialogContent>
    </Dialog>
  );
}
